import createIcon from '../../createIcon';

/**
 * @component @name Wifi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSA4Ljc3NzExTDMgMTAuNzc3MUM3Ljk3IDUuODA3MTEgMTYuMDMgNS44MDcxMSAyMSAxMC43NzcxTDIzIDguNzc3MTFDMTYuOTMgMi43MDcxMSA3LjA4IDIuNzA3MTEgMSA4Ljc3NzExWk05IDE2Ljc3NzFMMTIgMTkuNzc3MUwxNSAxNi43NzcxQzEzLjM1IDE1LjExNzEgMTAuNjYgMTUuMTE3MSA5IDE2Ljc3NzFaTTUgMTIuNzc3MUw3IDE0Ljc3NzFDOS43NiAxMi4wMTcxIDE0LjI0IDEyLjAxNzEgMTcgMTQuNzc3MUwxOSAxMi43NzcxQzE1LjE0IDguOTE3MTEgOC44NyA4LjkxNzExIDUgMTIuNzc3MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wifi = createIcon('Wifi', [
  [
    'path',
    {
      d: 'M1 8.77711L3 10.7771C7.97 5.80711 16.03 5.80711 21 10.7771L23 8.77711C16.93 2.70711 7.08 2.70711 1 8.77711ZM9 16.7771L12 19.7771L15 16.7771C13.35 15.1171 10.66 15.1171 9 16.7771ZM5 12.7771L7 14.7771C9.76 12.0171 14.24 12.0171 17 14.7771L19 12.7771C15.14 8.91711 8.87 8.91711 5 12.7771Z',
      key: 'njjb6l',
    },
  ],
]);

export default Wifi;
